import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./i18n";

import App from "./App";
// import * as serviceWorker from './serviceWorker';
//
import { CustomErrorBoundary } from "@components/CustomErrorBoundary";

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            {/* <PersistGate loading={null} persistor={persister}> */}
            <BrowserRouter>
                <ErrorBoundary FallbackComponent={CustomErrorBoundary}>
                    <App />
                </ErrorBoundary>
            </BrowserRouter>
            {/* </PersistGate> */}
        </Provider>
    </React.StrictMode>,
    document.getElementById("root")
);
//  serviceWorker.register("");
